import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { TAGGIS_QR_ROUTES } from '../../../constants';

import './styles.css';

/**
 * The Taggis logo in SVG background format
 *
 * @typedef {Object} Props
 * @prop {boolean} [white]
 * @prop {boolean} [animated]
 * @prop {String} [className]
 *
 * @augments {Component<Props>}
 */
export default class TaggisLogo extends Component {

	render () {
		/* eslint-disable max-len */
		return (
			<Link to={TAGGIS_QR_ROUTES.root}>
				<svg className='TaggisQrLogo' width='337' height='107' viewBox='0 0 337 107' fill='none' xmlns='http://www.w3.org/2000/svg'>
					<g clipPath='url(#clip0_602_852)'>
						<path d='M137.007 38.7892C137.762 38.7723 138.492 39.0531 139.031 39.5675C139.57 40.082 139.873 40.7867 139.871 41.5216C139.849 43.0362 138.588 44.256 137.032 44.2687H128.855L128.96 70.4122C128.964 71.1332 128.67 71.8254 128.143 72.3322C127.617 72.839 126.902 73.1173 126.162 73.1046C125.415 73.1215 124.692 72.8461 124.156 72.34C123.619 71.8339 123.314 71.1395 123.307 70.4122L123.203 44.3087H115.074C113.519 44.3088 112.253 43.0902 112.235 41.5763C112.231 40.8519 112.527 40.1562 113.057 39.6476C113.587 39.1392 114.306 38.8603 115.049 38.8751L137.007 38.7892ZM154.447 38.8126C155.633 38.7637 156.726 39.4405 157.181 40.5079L168.664 69.2579C169.195 70.6862 168.443 72.2636 166.979 72.7902C166.665 72.8936 166.334 72.9443 166.003 72.9396C164.848 72.9577 163.803 72.28 163.375 71.2365L160.826 64.9161H148.335L145.843 71.2833C145.397 72.3426 144.334 73.0323 143.158 73.0265C142.827 73.0293 142.498 72.9812 142.182 72.8849C140.719 72.3714 139.955 70.8035 140.472 69.3751L151.714 40.5314C152.173 39.464 153.259 38.7814 154.447 38.8126ZM190.241 37.6349C194.473 37.6041 198.599 38.9284 201.982 41.4035C202.601 41.8434 203.012 42.5077 203.122 43.2462C203.231 43.9851 203.029 44.736 202.562 45.3283C201.521 46.534 199.691 46.7339 198.401 45.7833C196.049 44.0824 193.194 43.1678 190.264 43.1769C186.813 43.1263 183.484 44.4242 181.023 46.7804C178.567 48.9555 177.175 52.044 177.193 55.2765C177.211 58.5089 178.639 61.5821 181.12 63.7306C183.592 66.064 186.92 67.3391 190.362 67.2716C192.836 67.2374 195.259 66.5854 197.401 65.379V58.6828H190.047C188.456 58.6915 187.152 57.4592 187.112 55.9113C187.139 54.3856 188.424 53.1657 189.991 53.1788H200.216C200.987 53.1449 201.739 53.4153 202.303 53.9279C202.868 54.4404 203.197 55.1523 203.216 55.9035L203.256 66.714C203.234 66.9951 203.186 67.2738 203.111 67.546C203.071 67.625 203.036 67.7062 203.006 67.7892V67.837C202.822 68.3231 202.479 68.7365 202.03 69.0138C198.684 71.5068 194.591 72.8642 190.378 72.8771C179.951 72.8771 171.379 65.1357 171.339 55.3536C171.298 45.5324 179.806 37.6742 190.241 37.6349ZM228.606 37.462C232.835 37.4364 236.956 38.7602 240.34 41.2306C240.96 41.6694 241.372 42.3336 241.483 43.0724C241.594 43.8113 241.394 44.5631 240.928 45.1564C239.884 46.3619 238.055 46.5648 236.758 45.6193C234.41 43.9161 231.559 42.9988 228.631 43.005C225.178 42.9564 221.849 44.2572 219.389 46.6163C216.943 48.7863 215.553 51.8629 215.565 55.0851C215.577 58.3074 216.99 61.3742 219.454 63.5265C221.935 65.8648 225.275 67.1377 228.727 67.0597C231.201 67.0283 233.625 66.3799 235.767 65.1759V58.4786H228.413C226.822 58.4877 225.517 57.2552 225.477 55.7072C225.486 54.9647 225.799 54.2565 226.347 53.7404C226.896 53.2242 227.634 52.9433 228.396 52.9601L238.525 52.9201H238.622C239.393 52.8861 240.145 53.1566 240.71 53.6691C241.274 54.1816 241.603 54.8936 241.622 55.6447L241.662 66.4865C241.643 66.7685 241.592 67.0477 241.508 67.3185C241.46 67.4204 241.46 67.4677 241.412 67.5617V67.6095C241.234 68.0987 240.89 68.5145 240.436 68.7872C237.087 71.2937 232.984 72.6564 228.759 72.6652C218.317 72.7044 209.744 64.9636 209.704 55.1896C209.663 45.3604 218.163 37.5092 228.606 37.462ZM254.392 38.3341C255.949 38.2992 257.243 39.4951 257.287 41.0109L257.408 69.8546C257.373 71.3673 256.091 72.569 254.537 72.547C253.792 72.5704 253.07 72.2986 252.535 71.7941C252 71.2895 251.699 70.5954 251.699 69.8703L251.578 41.0265C251.573 40.3028 251.87 39.608 252.4 39.1007C252.93 38.5935 253.649 38.3171 254.392 38.3341ZM278.17 37.2423C283.105 37.2423 286.766 39.5031 289.395 41.1046C289.97 41.4656 290.372 42.037 290.51 42.6896C290.648 43.3423 290.511 44.0224 290.129 44.5753C289.749 45.1473 289.15 45.5476 288.465 45.6876C287.781 45.8276 287.068 45.6953 286.484 45.3204C283.855 43.6718 281.331 42.1806 278.194 42.2277C276.139 42.2 274.124 42.7921 272.428 43.923C271.049 44.9043 270.485 45.9805 270.493 47.0089C270.468 47.4896 270.594 47.9667 270.855 48.3751C271.229 48.8823 271.704 49.3117 272.251 49.6388C274.241 50.7441 276.431 51.4658 278.702 51.7658H278.806C281.249 52.1625 283.634 52.8434 285.911 53.7921C287.976 54.6521 289.753 56.0579 291.04 57.8507C291.856 59.0901 292.29 60.5318 292.29 62.004C292.189 65.0801 290.551 67.9139 287.903 69.5949C285.114 71.4735 281.794 72.4621 278.403 72.422C272.847 72.4219 268.162 69.7754 265.218 67.5851C264.673 67.1649 264.321 66.5509 264.241 65.8781C264.161 65.2051 264.359 64.5289 264.792 63.9982C265.741 62.9206 267.394 62.7613 268.542 63.6369C270.745 65.3328 274.491 67.3011 278.037 67.3654H278.808C280.951 67.323 283.041 66.6871 284.831 65.5285C286.371 64.4452 287.032 63.2207 287.032 62.004C287.039 61.4471 286.876 60.9004 286.564 60.4337C286.165 59.8389 285.633 59.3391 285.007 58.9728C282.818 57.8084 280.43 57.0374 277.96 56.6964H277.855C275.569 56.3399 273.338 55.71 271.211 54.8204C269.274 54.0251 267.61 52.7097 266.413 51.0285C265.63 49.8324 265.215 48.4427 265.218 47.0245C265.318 44.1384 266.837 41.4744 269.299 39.8644C271.912 38.1294 275.007 37.2144 278.17 37.2423ZM150.367 59.5783L158.697 59.547L154.488 49.0499L150.367 59.5783Z' fill='white' />
						<path d='M304.845 94.0299C304.825 94.0999 304.715 94.2699 304.525 94.5499C304.335 94.8299 304.265 95.0599 304.305 95.2299C304.115 95.3199 303.855 95.4099 303.505 95.4999C303.225 95.4499 302.795 95.3999 302.215 95.3399C302.025 95.3899 301.725 95.4299 301.325 95.4599C300.925 95.4899 300.225 95.4899 299.225 95.4599C298.665 95.4399 297.335 95.2899 295.245 94.9899C294.705 94.8199 293.935 94.6599 292.935 94.4899C292.805 94.4899 292.465 94.7299 291.915 95.2399C290.685 96.3599 289.205 97.1399 287.475 97.5899C285.195 98.1699 283.255 97.7299 281.655 96.2499C280.235 94.9799 279.295 93.1699 278.845 90.8399C278.525 89.2599 278.605 87.4899 279.075 85.5099C279.645 83.0399 280.675 81.2199 282.165 80.0499C282.615 79.8699 283.315 79.6099 284.265 79.2699C284.675 79.1699 285.075 79.0999 285.465 79.0899C285.855 79.0699 286.165 79.0499 286.385 79.0399C288.495 78.9299 290.545 79.5699 292.535 80.9599C294.715 82.5099 296.025 84.1599 296.475 85.9299C296.575 86.3299 296.625 86.6799 296.615 86.9799C296.595 87.4899 296.425 88.2399 296.095 89.2299C295.705 90.3999 295.205 91.4099 294.595 92.2499C295.645 92.4499 297.495 92.5299 300.165 92.4999C300.865 92.3999 301.905 92.3699 303.285 92.3999C303.485 92.4499 303.795 92.7299 304.215 93.2499L304.825 94.0399L304.845 94.0299ZM293.445 85.1799C293.005 84.1199 292.145 83.1999 290.845 82.4199C289.475 81.5999 288.235 81.3199 287.135 81.5799C286.025 81.8399 284.815 82.1099 283.495 82.3899C281.935 84.6499 281.335 87.5899 281.695 91.2099C281.765 91.8799 282.025 92.6699 282.485 93.5799C282.685 93.9499 282.965 94.3799 283.335 94.8499C284.045 95.2799 284.905 95.3599 285.915 95.0999C287.005 94.8199 288.225 94.1799 289.565 93.1699C286.885 91.6699 285.385 90.3399 285.085 89.1599C285.035 88.9499 285.035 88.7499 285.085 88.5499C285.805 88.2699 286.815 88.5799 288.125 89.4999C289.715 90.5899 290.805 91.1699 291.405 91.2399C292.105 90.4199 292.675 89.4599 293.105 88.3799C293.655 87.0299 293.765 85.9599 293.435 85.1699L293.445 85.1799Z' fill='#F7AB59' />
						<path d='M326.505 89.3901C325.945 89.7801 325.735 90.1201 325.875 90.4401C325.705 90.4901 325.475 90.5301 325.185 90.5401C320.955 89.9001 318.055 89.3801 316.485 88.9601C312.835 88.0001 309.835 86.5801 307.505 84.7101C307.235 84.9001 306.805 85.2401 306.225 85.7301C307.025 88.0701 308.065 89.6401 309.925 91.8001C309.835 91.9601 308.985 92.3201 308.725 92.3701C308.735 92.9901 308.535 93.3301 308.125 93.4101C307.335 93.5601 307.205 92.8801 305.835 90.5301C305.235 89.5301 304.655 88.5001 304.065 87.4601C303.825 87.4601 303.535 87.5601 303.195 87.7401C302.865 87.9201 302.635 88.0201 302.515 88.0501C302.255 88.1001 302.075 87.9301 301.955 87.5301L301.595 87.6001C301.525 87.1001 301.325 86.5901 301.015 86.1001C300.965 85.8301 301.195 85.4801 301.705 85.0401C302.085 84.7701 302.465 84.4901 302.835 84.2001C302.685 83.7301 302.495 82.8801 302.265 81.6501C302.075 80.6301 301.835 79.3401 301.545 77.7801C301.135 77.9401 300.605 78.2801 299.965 78.8001C299.195 79.4201 298.855 79.9401 298.925 80.3401C298.965 80.5701 299.195 80.7601 299.615 80.9001C299.445 81.5301 298.955 81.9201 298.145 82.0701C296.765 82.3301 296.015 81.6701 295.905 80.0701C295.885 79.8501 296.025 79.4601 296.315 78.8901C296.605 78.3201 296.845 77.9201 297.035 77.7101C298.945 75.5401 301.285 74.2601 304.055 73.8701C304.945 73.7201 306.285 73.5101 308.075 73.2301C311.775 72.6701 314.145 73.2601 315.185 74.9901C315.295 75.1701 315.335 75.3501 315.285 75.5401C315.215 75.9301 315.145 76.3201 315.075 76.7201C314.975 77.1801 314.815 77.5401 314.595 77.8001C313.915 78.6501 313.085 79.6401 312.115 80.7801C311.505 81.3501 310.615 82.2101 309.435 83.3501C311.035 84.5001 312.875 85.3701 314.945 85.9501C316.115 86.2901 317.805 86.5901 320.025 86.8701C322.365 87.1601 324.055 87.4401 325.085 87.7101C325.235 87.7601 325.515 88.0001 325.925 88.4201C326.075 88.5901 326.275 88.9201 326.505 89.4201V89.3901ZM311.985 75.9101C310.305 75.7701 308.265 75.9201 305.875 76.3801C305.365 76.4801 304.825 76.5901 304.275 76.7101C304.515 79.3501 304.775 81.3601 305.025 82.7501C307.915 80.9401 310.235 78.6601 311.975 75.9101H311.985Z' fill='#F7AB59' />
						<path d='M63.2835 51.9341C61.5876 41.239 44.5136 42.9731 45.5755 54.3634C46.6984 66.3801 65.2315 64.2029 63.2835 51.9341Z' fill='url(#paint0_linear_602_852)' />
						<path d='M63.2835 51.9341C61.5876 41.239 44.5136 42.9731 45.5755 54.3634C46.6984 66.3801 65.2315 64.2029 63.2835 51.9341Z' fill='url(#paint1_linear_602_852)' />
						<path d='M95.0937 20.4447C93.4971 9.24535 76.1099 11.2087 77.4009 22.874C78.6614 34.3483 96.8126 32.4919 95.0937 20.4447Z' fill='url(#paint2_linear_602_852)' />
						<path d='M95.0937 20.4447C93.4971 9.24535 76.1099 11.2087 77.4009 22.874C78.6614 34.3483 96.8126 32.4919 95.0937 20.4447Z' fill='url(#paint3_linear_602_852)' />
						<path d='M31.4656 20.1238C29.7773 9.55861 13.5131 11.2393 13.7499 21.9038C14.0249 34.2949 33.5282 33.0344 31.4656 20.1238Z' fill='url(#paint4_linear_602_852)' />
						<path d='M31.4656 20.1238C29.7773 9.55861 13.5131 11.2393 13.7499 21.9038C14.0249 34.2949 33.5282 33.0344 31.4656 20.1238Z' fill='url(#paint5_linear_602_852)' />
						<path d='M95.0938 83.752C93.4131 73.0645 76.087 74.6382 77.3934 86.5021C78.6462 97.8924 97.0189 96.0055 95.0938 83.752Z' fill='url(#paint6_linear_602_852)' />
						<path d='M95.0938 83.752C93.4131 73.0645 76.087 74.6382 77.3934 86.5021C78.6462 97.8924 97.0189 96.0055 95.0938 83.752Z' fill='url(#paint7_linear_602_852)' />
						<path d='M31.4655 83.4316C29.7696 73.4852 13.1693 74.5012 13.7499 85.8533C14.361 97.8089 33.6886 96.4644 31.4655 83.4316Z' fill='url(#paint8_linear_602_852)' />
						<path d='M31.4655 83.4316C29.7696 73.4852 13.1693 74.5012 13.7499 85.8533C14.361 97.8089 33.6886 96.4644 31.4655 83.4316Z' fill='url(#paint9_linear_602_852)' />
						<path d='M79.9831 54.9668C81.2971 62.568 94.0777 61.1853 92.5575 52.2549C91.2359 44.5086 78.4323 45.9906 79.9831 54.9668Z' fill='url(#paint10_linear_602_852)' />
						<path d='M79.9831 54.9668C81.2971 62.568 94.0777 61.1853 92.5575 52.2549C91.2359 44.5086 78.4323 45.9906 79.9831 54.9668Z' fill='url(#paint11_linear_602_852)' />
						<path d='M64.0245 36.6173C62.6876 46.6707 78.7685 46.3116 76.6524 36.0291C75.3537 29.7266 64.9489 29.7113 64.0245 36.6173Z' fill='url(#paint12_linear_602_852)' />
						<path d='M64.0245 36.6173C62.6876 46.6707 78.7685 46.3116 76.6524 36.0291C75.3537 29.7266 64.9489 29.7113 64.0245 36.6173Z' fill='url(#paint13_linear_602_852)' />
						<path d='M66.301 74.3708C71.3429 78.3738 77.7906 74.0117 76.6446 67.8391C76.3925 66.4717 74.9487 64.7375 73.7646 64.0423C66.6447 59.856 60.3041 69.6038 66.301 74.3708Z' fill='url(#paint14_linear_602_852)' />
						<path d='M66.301 74.3708C71.3429 78.3738 77.7906 74.0117 76.6446 67.8391C76.3925 66.4717 74.9487 64.7375 73.7646 64.0423C66.6447 59.856 60.3041 69.6038 66.301 74.3708Z' fill='url(#paint15_linear_602_852)' />
						<path d='M58.0582 80.07C51.5495 75.7309 44.6359 84.5696 49.7924 89.7644C56.6297 96.6474 65.6823 85.1578 58.0582 80.07Z' fill='url(#paint16_linear_602_852)' />
						<path d='M58.0582 80.07C51.5495 75.7309 44.6359 84.5696 49.7924 89.7644C56.6297 96.6474 65.6823 85.1578 58.0582 80.07Z' fill='url(#paint17_linear_602_852)' />
						<path d='M48.1652 23.1494C49.4563 30.804 62.6494 29.3678 60.7396 20.1166C59.2423 12.8515 46.6679 14.3106 48.1652 23.1494Z' fill='url(#paint18_linear_602_852)' />
						<path d='M48.1652 23.1494C49.4563 30.804 62.6494 29.3678 60.7396 20.1166C59.2423 12.8515 46.6679 14.3106 48.1652 23.1494Z' fill='url(#paint19_linear_602_852)' />
						<path d='M42.344 64.2867C35.7665 59.6802 28.7077 68.6412 33.8872 73.8589C40.671 80.6885 49.6472 69.4051 42.344 64.2867Z' fill='url(#paint20_linear_602_852)' />
						<path d='M42.344 64.2867C35.7665 59.6802 28.7077 68.6412 33.8872 73.8589C40.671 80.6885 49.6472 69.4051 42.344 64.2867Z' fill='url(#paint21_linear_602_852)' />
						<path d='M44.8345 36.0289C44.5824 34.6615 43.1385 32.9273 41.9544 32.2322C34.9339 28.1069 28.5321 37.8242 34.4908 42.5606C39.5328 46.5712 45.9957 42.2932 44.8345 36.0289Z' fill='url(#paint22_linear_602_852)' />
						<path d='M44.8345 36.0289C44.5824 34.6615 43.1385 32.9273 41.9544 32.2322C34.9339 28.1069 28.5321 37.8242 34.4908 42.5606C39.5328 46.5712 45.9957 42.2932 44.8345 36.0289Z' fill='url(#paint23_linear_602_852)' />
						<path d='M28.9217 51.9338C27.7528 45.5855 16.9966 45.5703 16.3014 52.8506C15.4 62.3234 30.8468 62.3845 28.9217 51.9338Z' fill='url(#paint24_linear_602_852)' />
						<path d='M28.9217 51.9338C27.7528 45.5855 16.9966 45.5703 16.3014 52.8506C15.4 62.3234 30.8468 62.3845 28.9217 51.9338Z' fill='url(#paint25_linear_602_852)' />
						<path d='M34.8728 84.1414C33.2532 90.2529 42.726 91.0397 42.5656 85.3178C42.4434 80.8946 35.9881 79.9397 34.8728 84.1414Z' fill='url(#paint26_linear_602_852)' />
						<path d='M34.8728 84.1414C33.2532 90.2529 42.726 91.0397 42.5656 85.3178C42.4434 80.8946 35.9881 79.9397 34.8728 84.1414Z' fill='url(#paint27_linear_602_852)' />
						<path d='M82.5958 70.8035C83.7035 75.0357 91.3505 73.9433 90.0136 68.1527C89.074 64.0732 81.0145 64.7684 82.5958 70.8035Z' fill='url(#paint28_linear_602_852)' />
						<path d='M82.5958 70.8035C83.7035 75.0357 91.3505 73.9433 90.0136 68.1527C89.074 64.0732 81.0145 64.7684 82.5958 70.8035Z' fill='url(#paint29_linear_602_852)' />
						<path d='M66.6906 86.7084C67.7983 90.8642 75.453 89.9016 74.1084 84.0575C73.1688 79.9705 65.094 80.6886 66.6906 86.7084Z' fill='url(#paint30_linear_602_852)' />
						<path d='M66.6906 86.7084C67.7983 90.8642 75.453 89.9016 74.1084 84.0575C73.1688 79.9705 65.094 80.6886 66.6906 86.7084Z' fill='url(#paint31_linear_602_852)' />
						<path d='M34.7123 22.2707C35.1401 27.0758 42.7107 26.5945 42.5732 21.6824C42.4281 16.4953 34.2158 16.6787 34.7123 22.2707Z' fill='url(#paint32_linear_602_852)' />
						<path d='M34.7123 22.2707C35.1401 27.0758 42.7107 26.5945 42.5732 21.6824C42.4281 16.4953 34.2158 16.6787 34.7123 22.2707Z' fill='url(#paint33_linear_602_852)' />
						<path d='M26.6603 69.4129C26.5305 64.8675 19.7925 64.1036 18.8911 68.4809C17.6688 74.4473 26.8208 74.9973 26.6603 69.4129Z' fill='url(#paint34_linear_602_852)' />
						<path d='M26.6603 69.4129C26.5305 64.8675 19.7925 64.1036 18.8911 68.4809C17.6688 74.4473 26.8208 74.9973 26.6603 69.4129Z' fill='url(#paint35_linear_602_852)' />
						<path d='M58.2033 68.1527C57.4547 64.8907 51.7786 64.5087 50.7855 68.2367C49.0285 74.8524 59.8152 75.2038 58.2033 68.1527Z' fill='url(#paint36_linear_602_852)' />
						<path d='M58.2033 68.1527C57.4547 64.8907 51.7786 64.5087 50.7855 68.2367C49.0285 74.8524 59.8152 75.2038 58.2033 68.1527Z' fill='url(#paint37_linear_602_852)' />
						<path d='M34.7122 54.0883C35.163 58.8858 42.7106 58.3511 42.5731 53.5001C42.428 48.3206 34.1851 48.4428 34.7122 54.0883Z' fill='url(#paint38_linear_602_852)' />
						<path d='M34.7122 54.0883C35.163 58.8858 42.7106 58.3511 42.5731 53.5001C42.428 48.3206 34.1851 48.4428 34.7122 54.0883Z' fill='url(#paint39_linear_602_852)' />
						<path d='M82.5957 38.9854C83.7034 43.2176 91.3428 42.1328 90.0136 36.3346C89.1045 32.3927 81.0068 32.9198 82.5957 38.9854Z' fill='url(#paint40_linear_602_852)' />
						<path d='M82.5957 38.9854C83.7034 43.2176 91.3428 42.1328 90.0136 36.3346C89.1045 32.3927 81.0068 32.9198 82.5957 38.9854Z' fill='url(#paint41_linear_602_852)' />
						<path d='M25.8201 35.3108C22.7338 30.9869 15.8965 36.4719 19.8767 40.452C23.1463 43.7217 28.7918 39.4742 25.8201 35.3108Z' fill='url(#paint42_linear_602_852)' />
						<path d='M25.8201 35.3108C22.7338 30.9869 15.8965 36.4719 19.8767 40.452C23.1463 43.7217 28.7918 39.4742 25.8201 35.3108Z' fill='url(#paint43_linear_602_852)' />
						<path d='M58.2033 36.3344C57.3782 32.7439 50.7473 32.9196 50.6098 37.5414C50.4341 43.2939 59.693 42.8202 58.2033 36.3344Z' fill='url(#paint44_linear_602_852)' />
						<path d='M58.2033 36.3344C57.3782 32.7439 50.7473 32.9196 50.6098 37.5414C50.4341 43.2939 59.693 42.8202 58.2033 36.3344Z' fill='url(#paint45_linear_602_852)' />
						<path d='M74.1084 52.2475C73.3751 49.0466 67.6608 48.6799 66.6906 52.3315C64.9106 59.0542 75.7127 59.2146 74.1084 52.2475Z' fill='url(#paint46_linear_602_852)' />
						<path d='M74.1084 52.2475C73.3751 49.0466 67.6608 48.6799 66.6906 52.3315C64.9106 59.0542 75.7127 59.2146 74.1084 52.2475Z' fill='url(#paint47_linear_602_852)' />
						<path d='M74.1084 20.4291C73.2834 16.8386 66.6524 17.0143 66.5149 21.6362C66.3392 27.3886 75.5981 26.915 74.1084 20.4291Z' fill='url(#paint48_linear_602_852)' />
						<path d='M74.1084 20.4291C73.2834 16.8386 66.6524 17.0143 66.5149 21.6362C66.3392 27.3886 75.5981 26.915 74.1084 20.4291Z' fill='url(#paint49_linear_602_852)' />
					</g>
					<defs>
						<linearGradient id='paint0_linear_602_852' x1='62.2827' y1='58.0762' x2='46.6373' y2='49.0464' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint1_linear_602_852' x1='62.2827' y1='58.0762' x2='46.6373' y2='49.0464' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint2_linear_602_852' x1='94.1006' y1='26.3117' x2='78.4628' y2='17.282' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint3_linear_602_852' x1='94.1006' y1='26.3117' x2='78.4628' y2='17.282' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint4_linear_602_852' x1='30.5488' y1='26.2735' x2='14.9111' y2='17.2515' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint5_linear_602_852' x1='30.5488' y1='26.2735' x2='14.9111' y2='17.2515' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint6_linear_602_852' x1='94.1006' y1='89.8711' x2='78.4552' y2='80.8414' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint7_linear_602_852' x1='94.1006' y1='89.8711' x2='78.4552' y2='80.8414' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint8_linear_602_852' x1='30.5335' y1='89.8563' x2='14.8728' y2='80.8113' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint9_linear_602_852' x1='30.5335' y1='89.8563' x2='14.8728' y2='80.8113' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint10_linear_602_852' x1='91.8852' y1='56.8232' x2='80.6477' y2='50.3374' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint11_linear_602_852' x1='91.8852' y1='56.8232' x2='80.6477' y2='50.3374' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint12_linear_602_852' x1='76.0565' y1='40.9412' x2='64.7426' y2='34.4095' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint13_linear_602_852' x1='76.0565' y1='40.9412' x2='64.7426' y2='34.4095' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint14_linear_602_852' x1='75.9113' y1='72.6595' x2='64.8495' y2='66.273' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint15_linear_602_852' x1='75.9113' y1='72.6595' x2='64.8495' y2='66.273' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint16_linear_602_852' x1='59.9451' y1='88.565' x2='48.9445' y2='82.209' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint17_linear_602_852' x1='59.9451' y1='88.565' x2='48.9445' y2='82.209' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint18_linear_602_852' x1='60.1208' y1='25.0287' x2='48.8757' y2='18.5352' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint19_linear_602_852' x1='60.1208' y1='25.0287' x2='48.8757' y2='18.5352' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint20_linear_602_852' x1='44.0399' y1='72.6595' x2='33.0469' y2='66.3112' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint21_linear_602_852' x1='44.0399' y1='72.6595' x2='33.0469' y2='66.3112' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint22_linear_602_852' x1='44.1164' y1='40.857' x2='33.0852' y2='34.4858' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint23_linear_602_852' x1='44.1164' y1='40.857' x2='33.0852' y2='34.4858' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint24_linear_602_852' x1='28.3487' y1='56.8078' x2='17.0883' y2='50.3067' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint25_linear_602_852' x1='28.3487' y1='56.8078' x2='17.0883' y2='50.3067' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint26_linear_602_852' x1='42.1072' y1='87.3804' x2='35.1631' y2='83.3698' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint27_linear_602_852' x1='42.1072' y1='87.3804' x2='35.1631' y2='83.3698' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint28_linear_602_852' x1='89.6775' y1='71.4376' x2='82.8326' y2='67.4804' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint29_linear_602_852' x1='89.6775' y1='71.4376' x2='82.8326' y2='67.4804' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint30_linear_602_852' x1='73.7876' y1='87.3348' x2='66.9275' y2='83.3776' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint31_linear_602_852' x1='73.7876' y1='87.3348' x2='66.9275' y2='83.3776' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint32_linear_602_852' x1='42.0537' y1='23.7909' x2='35.1707' y2='19.8184' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint33_linear_602_852' x1='42.0537' y1='23.7909' x2='35.1707' y2='19.8184' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint34_linear_602_852' x1='26.1943' y1='71.4755' x2='19.2425' y2='67.4649' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint35_linear_602_852' x1='26.1943' y1='71.4755' x2='19.2425' y2='67.4649' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint36_linear_602_852' x1='57.9283' y1='71.43' x2='51.0758' y2='67.4728' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint37_linear_602_852' x1='57.9283' y1='71.43' x2='51.0758' y2='67.4728' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint38_linear_602_852' x1='42.046' y1='55.5933' x2='35.1553' y2='51.6132' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint39_linear_602_852' x1='42.046' y1='55.5933' x2='35.1553' y2='51.6132' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint40_linear_602_852' x1='89.6698' y1='39.6348' x2='82.8249' y2='35.6852' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint41_linear_602_852' x1='89.6698' y1='39.6348' x2='82.8249' y2='35.6852' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint42_linear_602_852' x1='26.1104' y1='39.6423' x2='19.319' y2='35.7233' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint43_linear_602_852' x1='26.1104' y1='39.6423' x2='19.319' y2='35.7233' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint44_linear_602_852' x1='57.8977' y1='39.627' x2='51.0987' y2='35.7003' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint45_linear_602_852' x1='57.8977' y1='39.627' x2='51.0987' y2='35.7003' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint46_linear_602_852' x1='73.8029' y1='55.5401' x2='66.9733' y2='51.5982' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint47_linear_602_852' x1='73.8029' y1='55.5401' x2='66.9733' y2='51.5982' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint48_linear_602_852' x1='73.8105' y1='23.7217' x2='67.0038' y2='19.7951' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<linearGradient id='paint49_linear_602_852' x1='73.8105' y1='23.7217' x2='67.0038' y2='19.7951' gradientUnits='userSpaceOnUse'>
							<stop stopColor='#FFF26E' />
							<stop offset='0.02' stopColor='#FEEC69' />
							<stop offset='0.13' stopColor='#FDDA59' />
							<stop offset='0.24' stopColor='#FDCE50' />
							<stop offset='0.35' stopColor='#FDCB4D' />
							<stop offset='0.56' stopColor='#E39E58' />
							<stop offset='0.8' stopColor='#D26F41' />
							<stop offset='1' stopColor='#A8743A' />
						</linearGradient>
						<clipPath id='clip0_602_852'>
							<rect width='336' height='107' fill='white' transform='translate(0.234985)' />
						</clipPath>
					</defs>
				</svg>
			</Link>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/atoms/TaggisQrLogo/TaggisQrLogo.js